import { ReactNode, useMemo } from 'react';

import { ButtonName, StyledButton, StyledLoader } from './styled';

type Props = {
  name?: string;
  type?: 'submit' | 'reset' | 'button';
  variant?: 'normal' | 'outlined' | 'tertiary';
  onClick?: () => void;
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
};

const Button = ({
  name,
  className,
  type = 'button',
  variant = 'normal',
  isLoading,
  children,
  ...rest
}: Props): JSX.Element => {
  const currentVariant = useMemo<Props['variant']>(() => (variant === 'tertiary' ? 'outlined' : variant), [variant]);
  const currentClassName = useMemo<string | undefined>(
    () => (variant === 'tertiary' ? `tertiaryButton ${className}` : className),
    [className, variant]
  );

  return (
    <StyledButton {...rest} type={type} variant={currentVariant} className={currentClassName}>
      <ButtonName isLoading={isLoading}>
        {children ?? name}
        {isLoading && <StyledLoader data-testid="buttonLoader" />}
      </ButtonName>
    </StyledButton>
  );
};

export default Button;
